import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";

const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
    width: "100vw",
    height: "98vh",
    overflow: "hidden", // bloqueia scroll
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
  },
  cover: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "110px", // ajusta conforme a altura do rodapé
    backgroundColor: "#fff", // pode trocar a cor pra combinar
    zIndex: 2,
    pointerEvents: "none",
  },
}));

const PowerBIEmbedCompliance = () => {
  const classes = useStyles();

  // Remove scroll do body também
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className={classes.root}>
      <iframe
        className={classes.iframe}
        title="Compliance"
        src="https://app.powerbi.com/view?r=eyJrIjoiZDk5MDA2OTItMDRmMi00NzhiLWJlODItODFiMzlhNjI0YzFjIiwidCI6ImU0OTc4M2E2LTllOGYtNDQ5My1iNDc5LTQ3OGU0MGY5M2ZlYSJ9"
      />
      <div className={classes.cover} />
    </div>
  );
};

export default PowerBIEmbedCompliance;
